import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Icon } from 'antd';

import { rutaLogin } from '../../../routes/routeConstants';
import { eliminarToken } from '../../../commons/gestioWebToken';
import { loginEsborrarDadesUsuariRegistrat } from '../../../actions';

class Logout extends Component {

    constructor(props) {
        super(props);
        this.ferLogout = this.ferLogout.bind(this);
    }

    ferLogout() {
        const { loginEsborrarDadesUsuariRegistrat } = this.props;
        loginEsborrarDadesUsuariRegistrat();
        eliminarToken();
    }

    render() {
        return (

            <Link onClick={this.ferLogout} to={rutaLogin}>
                <Icon type='logout' />
                Tancar sessió
            </Link>
        );
    }
}

Logout.propTypes = {
    loginEsborrarDadesUsuariRegistrat: PropTypes.func
};

export default connect(null, { loginEsborrarDadesUsuariRegistrat })(Logout);



// WEBPACK FOOTER //
// ./src/components/capcalera/menu/logout.js